import { DemandCapacityEvent } from '../../event-types';
import { demandEventTemplate } from './demand-event-template';

export const demandCapacityTemplate = ({
  id,
  capacity,
}: Pick<DemandCapacityEvent, 'id' | 'capacity'>): string =>
  demandEventTemplate({ id, value: capacity });
